import React, { useEffect, useState } from 'react';
import { Affix, Alert, Button, Card, Divider, notification, Space, Steps, theme, App } from 'antd';
import { _T } from '../../../../../base-react/src/Localization';
import { CheckOutlined, GlobalOutlined, SolutionOutlined, StopOutlined, TagOutlined, UndoOutlined } from '@ant-design/icons';
import { apis, hooks, models } from "@vote4dance/judging-sdk";
import { JudgingType, RoundStatus, RoundType } from "@vote4dance/judging-schema";
var Api = apis.Api;
var RoundItem = models.rounds.RoundItem;
import { RoundAddTeamsButton } from './RoundAddTeamsButton';
import { RoundPathParent } from '../../../../components/RoundPathParent';
var Stream = hooks.streams.Stream;
var RoundTeamSource = models.teams.RoundTeamSource;
var ClassRoundSource = models.rounds.ClassRoundSource;
const { useToken } = theme;
export const RoundStatusView = (props) => {
    const { round, classRounds, disabled, hasChanges } = props;
    const { modal } = App.useApp();
    const [loadingRoundStatus, setLoadingRoundStatus] = useState(false);
    const { token } = useToken();
    const [affixed, setAffixed] = useState();
    const [teams] = Stream(RoundTeamSource(round.round_id));
    useEffect(() => {
        if (loadingRoundStatus) {
            setLoadingRoundStatus(false);
        }
    }, [round]);
    //TODO: Also check if all checkins are applied
    const canStartRound = round.round_status == RoundStatus.Open && round.round_count > 0 && round.round_type != RoundType.Skating;
    const canGoBack = round.round_status != RoundStatus.Open || round.round_published > 0;
    const canCloseRound = round.round_status == RoundStatus.Ready && round.round_type != RoundType.Skating;
    const canConfirmRound = round.round_status == RoundStatus.Closed && round.round_type != RoundType.Skating;
    const canPublishRound = (!RoundItem.isChildRound(round) || round.round_type == RoundType.Chance) && round.round_status == RoundStatus.Confirmed && round.round_published == 0 && round.round_type != RoundType.Skating;
    const confirmIfDirty = async () => {
        if (!hasChanges)
            return true;
        return new Promise((resolve) => {
            modal.confirm({
                title: _T('common.confirm'),
                content: _T('common.unsaved'),
                onOk: () => resolve(true),
                onCancel: () => resolve(false),
            });
        });
    };
    const setRoundStatus = async (status) => {
        const ok = await confirmIfDirty();
        if (!ok)
            return;
        const childRounds = classRounds === null || classRounds === void 0 ? void 0 : classRounds.filter(a => a.round_parent_id === round.round_id && a.round_type === RoundType.Normal);
        const allJudgesDone = (childRounds && childRounds.length > 0) ? childRounds.every(a => a.round_judges_done > 0) : round.round_judges_done > 0;
        if (!RoundItem.isPointSummary(round) && round.round_status == RoundStatus.Ready && status == RoundStatus.Closed && round.judging_type != JudgingType.None && !allJudgesDone) {
            modal.confirm({
                title: _T('round.status.closed.action'),
                content: _T('round.status.closed.warning'),
                onOk: () => setRoundStatusCmd(status)
            });
        }
        else {
            setRoundStatusCmd(status);
        }
    };
    const setRoundStatusCmd = (status) => {
        setLoadingRoundStatus(true);
        Api.call(`${ClassRoundSource(round.class_id).url}/${round.round_id}`, "set-round-status", { round_status: status })
            .catch(err => {
            setLoadingRoundStatus(false);
            notification.error({
                message: _T(err.name)
            });
        });
    };
    const setRoundPublished = (value) => {
        setLoadingRoundStatus(true);
        Api.call(`${ClassRoundSource(round.class_id).url}/${round.round_id}`, "publish-round", { round_published: value })
            .catch(err => {
            setLoadingRoundStatus(false);
            notification.error({
                message: _T(err.name)
            });
        });
    };
    const confirmAndSendTeams = () => {
        const hasConflictingPlacements = (teams) => {
            const placements = teams === null || teams === void 0 ? void 0 : teams.map(team => team.heats_team_placement);
            const uniquePlacements = new Set(placements);
            return (placements === null || placements === void 0 ? void 0 : placements.length) !== uniquePlacements.size;
        };
        const hasNoTargets = (teams) => {
            return teams === null || teams === void 0 ? void 0 : teams.every(a => parseInt(a.heats_team_target_id) === 0);
        };
        if (RoundItem.isFinalRound(round)) {
            if (RoundItem.usesPlacement(round) && hasConflictingPlacements(teams)) {
                modal.confirm({
                    title: _T('round.status.confirmed.action'),
                    content: _T('round.status.confirmed.warning'),
                    onOk: () => confirmAndSendTeamsCmd()
                });
            }
            else {
                confirmAndSendTeamsCmd();
            }
        }
        else {
            if (!RoundItem.usesPriority(round) && hasNoTargets(teams)) {
                modal.confirm({
                    title: _T('round.status.confirmed.action'),
                    content: _T('round.status.confirmed.targets'),
                    onOk: () => confirmAndSendTeamsCmd()
                });
            }
            else {
                confirmAndSendTeamsCmd();
            }
        }
    };
    const confirmAndSendTeamsCmd = () => {
        setLoadingRoundStatus(true);
        Api.call(`${ClassRoundSource(round.class_id).url}/${round.round_id}`, "send-teams")
            .then(() => {
            setRoundStatus(RoundStatus.Confirmed);
        })
            .catch(err => {
            setLoadingRoundStatus(false);
            notification.error({
                message: _T(err.name)
            });
        });
    };
    const steps = ['open', 'ready', 'closed', 'confirmed', 'published'];
    const currentStep = steps.findIndex(step => step == (round.round_published ? 'published' : round.round_status));
    const goBack = () => {
        if (round.round_published) {
            setRoundPublished(0);
        }
        else {
            setRoundStatus(steps[currentStep - 1]);
        }
    };
    const onChangeStep = (value) => {
        const currentValue = steps[value];
        if (currentValue != 'published') {
            if (round.round_published) {
                setRoundPublished(0);
            }
            setRoundStatus(steps[value]);
        }
        else if (!round.round_published) {
            setRoundPublished(1);
            setRoundStatus(RoundStatus.Confirmed);
        }
    };
    return (React.createElement(Card, { title: React.createElement(React.Fragment, null,
            React.createElement(TagOutlined, null),
            " ",
            _T('round.status.title')) },
        React.createElement(Steps, { size: 'small', current: currentStep, items: steps.map((status) => ({
                title: _T('round.status.' + status + '.title'),
                content: _T('round.status.' + status + '.info'),
                disabled: disabled
            })), onChange: onChangeStep }),
        React.createElement(Divider, { style: { marginBottom: 0 } }),
        React.createElement("style", null, `
                .round-status-affix.ant-affix {
                    --ant-affix-z-index-popup: 14;
                    z-index: var(--ant-affix-z-index-popup);
                }
            `),
        React.createElement(Affix, { rootClassName: "round-status-affix", onChange: value => setAffixed(value) },
            React.createElement(Space, { size: [8, 8], wrap: true, style: { backgroundColor: token.colorBgContainer, padding: 16 } },
                React.createElement(RoundAddTeamsButton, { round: round, size: "large", disabled: disabled }),
                canStartRound &&
                    React.createElement(Button, { key: "start", size: "large", type: "primary", disabled: disabled, icon: React.createElement(SolutionOutlined, null), onClick: () => setRoundStatus(RoundStatus.Ready), loading: loadingRoundStatus }, _T('round.status.ready.action')),
                canGoBack &&
                    React.createElement(Button, { key: "open", size: "large", disabled: disabled, icon: React.createElement(UndoOutlined, null), onClick: goBack, loading: loadingRoundStatus }, _T('round.status.revert')),
                canCloseRound &&
                    React.createElement(Button, { key: "close", size: "large", type: "primary", disabled: disabled, icon: React.createElement(StopOutlined, null), onClick: () => setRoundStatus(RoundStatus.Closed), loading: loadingRoundStatus }, _T('round.status.closed.action')),
                canConfirmRound &&
                    React.createElement(Button, { key: "confirm", size: "large", type: "primary", disabled: disabled, icon: React.createElement(CheckOutlined, null), onClick: confirmAndSendTeams, loading: loadingRoundStatus }, _T('round.status.confirmed.action')),
                canPublishRound &&
                    React.createElement(Button, { key: "confirm", size: "large", type: "primary", disabled: disabled, icon: React.createElement(GlobalOutlined, null), onClick: () => setRoundPublished(1), loading: loadingRoundStatus }, _T('round.status.published.action')),
                affixed &&
                    React.createElement(RoundPathParent, { record: round }, (round, parents) => React.createElement("strong", null,
                        React.createElement(Space, { wrap: true, separator: React.createElement(Divider, { orientation: 'vertical' }), size: 'small' },
                            (round.round_beat || round.floor_code) && React.createElement("span", null,
                                round.round_beat,
                                round.floor_code),
                            RoundItem.getClassLabel(round),
                            parents ? parents.map((parent, index) => React.createElement("div", { key: index }, RoundItem.getRoundLabel(parent))) :
                                RoundItem.getRoundLabel(round)))))),
        disabled &&
            React.createElement(Alert, { title: _T('competition.status.disabled') })));
};
